import { css } from '@emotion/core';
import { variables, tokens } from '@domain-group/fe-brary';
var font = variables.font;
var colors = tokens.colors;

/* eslint-disable import/prefer-default-export */

export var label = /*#__PURE__*/css("display:inline-block;font-family:", font.bodyFontFamily, ";font-size:", font.baseFontSize, ";line-height:", font.baseLineHeight, ";font-weight:", font.headingFontWeight, ";color:", colors.neutral.surface.base, ";margin-bottom:15px;");